//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button as MaterialButton,
    IconButton,
    Select,
    MenuItem,
    Menu,
    InputLabel,
    FormControl,
    TextField,
    Chip,
    createTheme,
    ThemeProvider,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    CircularProgress,
    useTheme,
    Tooltip,
    Stack,
    Checkbox
} from '@mui/material';
import { createBooleanOperator, DateTimePickerControl, InputControl, NumericFormatInputControl } from '../../molecules';
import { useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal, useGetMerchantPOSUsageFee, GetMerchantUsageFeeRequestDto, useGetAllMerchantList } from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Table } from '../../../components';
import {
    GridColDef,
    GridPaginationModel,
    GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';
import { months, monthFilterOperator, MonthFilter } from '../../../components/atoms/grid-filter-operations';
import BaseFilterTableWithAccordion from '../../../components/atoms/BaseFilterTableWithAccordion';
import * as zod from 'zod';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Button } from "../../atoms";

const currentYear = new Date().getFullYear();
const startYear = 2000;
const years = [];

for (let year = currentYear; year >= startYear; year--) {
    years.push({ name: year.toString(), value: year });
}

const MerchantPOSUsageFeeComponentRequestSchema = zod.object({
    merchantId: zod.any(),
    selectedYear: zod.any(),
    selectedMonth: zod.any()
});

type MerchantPOSUsageFeeComponentFormRequest = zod.infer<
    typeof MerchantPOSUsageFeeComponentRequestSchema
>;

const MerchantPOSUsageFeeComponentFormRequestInitValues: MerchantPOSUsageFeeComponentFormRequest =
{
    merchantId: null,
    selectedMonth: null,
    selectedYear: null
};

export const MerchantPOSUsageFeeComponent = ({ merchant }: any) => {
    const theme = useTheme();
    const { showDelete, showUpdate, showCreate } = useAuthorization();
    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
    const [showTable, setShowTable] = useState(false)
    const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [isTableSubmitted, setIsTableSubmitted] = useState(false);

    const { mutate: getMerchantPOSUsageFee, isLoading: isGetMerchantPOSUsageFeeLoading } = useGetMerchantPOSUsageFee();
    const { data: rawMerchantList, isLoading: isGetAllMerchantListLoading } = useGetAllMerchantList("ACTIVE");

    var isPageLoading = isGetMerchantPOSUsageFeeLoading ||
        isGetAllMerchantListLoading;

    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantPOSUsageFeeComponentFormRequest>({
            resolver: zodResolver(MerchantPOSUsageFeeComponentRequestSchema),
            defaultValues: MerchantPOSUsageFeeComponentFormRequestInitValues,
        });

    const setSnackbar = useSetSnackBar();


    const merchantList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data]);

    interface QueryOptions {
        field?: string;
        value?: any;
        clearFilter?: boolean;
        [key: string]: string | number | boolean | undefined | any;
    }

    const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });

    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const [dynamicFilters, setDynamicFilter] = useState<any>([]);

    useEffect(() => {
        let payload: GetMerchantUsageFeeRequestDto = {
            filters: dynamicFilters,
            orderBy: "createDate",
            orderByDesc: true,
            page: paginationModel.page,
            size: paginationModel.pageSize,
            status: "ACTIVE"
        };

        getMerchantPOSUsageFee(payload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setTableData(data.data);
                } else {
                    setTableData({});
                    setSnackbar({
                        severity: "error",
                        description: "Bir hata oluştu.",
                        isOpen: true,
                    });
                }
            },
            onError: (error) => {
                setTableData({});
                setSnackbar({
                    severity: "error",
                    description: error.message || "Bir hata oluştu.",
                    isOpen: true,
                });
            }
        });
    }, [paginationModel, queryOptions, dynamicFilters, isTableSubmitted]);

    const debounce = (func: (...args: any[]) => void, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    interface FilterParams {
        [key: string]: string | number | boolean | null | undefined;
    }

    const getQueryParams = (filters: FilterParams) => {
        const queryParams: { [key: string]: string | number | boolean } = {};

        for (let key in filters) {
            let value = filters[key];
            // Eğer gelen değer string "false" ise onu boolean false'a çevir
            if (value === "false") {
                queryParams[key] = false;
            } else {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            return setQueryOptions({});
        }
        const queryParams = getQueryParams(filters);

        const isValueValid = (key: string, value: any): boolean => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'selectedMonth' || key === 'totalCount' || key === 'totalChargeAmount') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }

        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
        }


        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

    const booleanOptions = [
        { label: "Evet", value: true },
        { label: "Hayır", value: "false" },
    ];

    const columns: GridColDefExt[] = useMemo(() => {
        return [
            { field: 'merchantId', headerName: 'Üye No.', width: 120, columnType: RequestFilterValueTypeEnums.NUMBER },
            { field: 'merchantName', headerName: 'Üye İşyeri Adı', width: 250, columnType: RequestFilterValueTypeEnums.STRING, flex: 1 },
            {
                field: 'selectedMonth', headerName: 'Ay', width: 100, columnType: RequestFilterValueTypeEnums.NUMBER, filterOperators: [monthFilterOperator], // Use custom filter operator
                valueFormatter: ({ value }) => {
                    // Display Turkish month name in the grid
                    const month = months.find((m) => m.value === value);
                    return month ? month.name : value;
                },
            },
            { field: 'selectedYear', headerName: 'Yıl', width: 100, columnType: RequestFilterValueTypeEnums.NUMBER },
            { field: 'totalCount', headerName: 'Adet', width: 100, columnType: RequestFilterValueTypeEnums.NUMBER, filterable: false },
            { field: 'totalChargeAmount', headerName: 'Toplam Ödeme Tutarı', width: 250, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false },
            {
                field: 'isComplated', headerName: 'Tamamlandı mı?', width: 150, columnType: RequestFilterValueTypeEnums.BOOLEAN,
                valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
                filterOperators: [createBooleanOperator(booleanOptions)],
            },

        ];
    }, [menuAnchorEl, showUpdate, showDelete]);

    const convertTableFiltersToRequestFilter = (tableFilters: any) => {

        let convertedFilters: any = [];

        tableFilters.items.map((item: any) => {

            var findColumn = columns.find(x => x.field == item.field);

            convertedFilters.push({
                field: item.field,
                values: [item.value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    function fieldValue(data: any[]): Record<string, string | number | boolean | undefined>[] {
        return data.map((item) => {
            return {
                'Üye No.': item?.merchantId,
                'Üye İşyeri Adı': item?.merchantName,
                'Ay': months.find((m) => m.value === item?.selectedMonth)?.name ?? item?.selectedMonth,
                'Yıl': item?.selectedYear,
                'Adet': item?.totalCount,
                'Toplam Ödeme Tutarı': item?.totalChargeAmount,
                'Tamamlandı mı?': item?.isComplated ? 'Evet' : 'Hayır',
            };
        });
    }
    const onSave = () => {

        let payload: GetMerchantUsageFeeRequestDto = {
            filters: dynamicFilters,
            orderBy: "createDate",
            orderByDesc: true,
            page: 0,
            size: tableData?.totalItems ?? 99,
            status: "ACTIVE"
        };

        getMerchantPOSUsageFee(payload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    const refactoredData = fieldValue(data?.data?.result);
                    downloadExcel(refactoredData || [], "Cari-POS-kullanim-bedeli");
                } else {
                    setSnackbar({
                        severity: "error",
                        description: "Bir hata oluştu.",
                        isOpen: true,
                    });
                }
            },
            onError: (error) => {
                setSnackbar({
                    severity: "error",
                    description: error.message || "Bir hata oluştu.",
                    isOpen: true,
                });
            }
        });
    };


    const onSubmit = (data: MerchantPOSUsageFeeComponentFormRequest) => {
        console.log('data', data);
        setFilterAccordionExpand(false);
        setTableData(undefined);
        setShowTable(true);
        let newFilter = [...dynamicFilters];

        if (data.merchantId && data.merchantId.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'merchantId')) {
                newFilter.find((filter: any) => filter.field === 'merchantId').values = data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'merchantId',
                    values: data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'merchantId');
        }


        if (data.selectedYear && data.selectedYear.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'selectedYear')) {
                newFilter.find((filter: any) => filter.field === 'selectedYear').values = data.selectedYear ? data.selectedYear.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'selectedYear',
                    values: data.selectedYear ? data.selectedYear.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'selectedYear');
        }

        if (data.selectedMonth && data.selectedMonth.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'selectedMonth')) {
                newFilter.find((filter: any) => filter.field === 'selectedMonth').values = data.selectedMonth ? data.selectedMonth.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'selectedMonth',
                    values: data.selectedMonth ? data.selectedMonth.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.EQUALS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'selectedMonth');
        }

        setDynamicFilter(newFilter);
    }

    return (

        <ThemeProvider theme={theme}>
            {isPageLoading && <Loading />}
            <Box className="p-4" sx={{ p: 2 }}>

                <BaseFilterTableWithAccordion
                    isExpanded={isFilterAccordionExpanded}
                    setExpanded={setFilterAccordionExpand}
                    setTableVisibility={setShowTable}
                    child={<Stack spacing={4}>
                        <Stack
                            spacing={3}
                            direction={isDesktop ? "row" : "column"}
                            width={'100%'}
                        >
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        control={control}
                                        name="merchantId"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="merchant-single-select"
                                                options={merchantList}
                                                getOptionLabel={(option) => option.label}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                {months && (
                                    <Controller
                                        control={control}
                                        name="selectedMonth"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="month-single-select"
                                                options={months}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Ay" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                {years && (
                                    <Controller
                                        control={control}
                                        name="selectedYear"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="year-single-select"
                                                options={years}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Yıl" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <Button
                                onClick={handleSubmit(onSubmit)}
                                variant="contained"
                                text={"ARA"}
                            />
                        </Stack>
                    </Stack>}
                    summary={'Filtre yönetimi'}
                ></BaseFilterTableWithAccordion>

                <Box sx={{ mt: 2 }}>
                    {(tableData && showTable) && <Table
                        filterKey="merchantPOSUsageFeeFilterKey"
                        columnVisibilityConfigKey="merchantPOSUsageFeeFilterColumnVisibilityKey"
                        hasActiveFilters={hasActiveFilters}
                        handleFilterChange={handleFilterChange}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handleChangePagination}
                        paginationMode="server"
                        rowCount={tableData?.totalItems || 0}
                        isRowSelectable={() => false}
                        customLabelDisplayedRows={true}
                        autoHeight={false}
                        getRowId={() => { return Math.floor(Math.random() * 100000) }}
                        rows={tableData?.result || []}
                        columns={columns}
                        getRowClassName={(params: { row: { status: string } }) => {
                            if (params.row.status === "PASSIVE") return "blocked-row";
                            if (params.row.status === "BLOCKED") return "pasive-row";
                            return "";
                        }}
                        exportFileName="Üye İşyeri POS Kullanım Bedeli Raporu"
                        onSave={onSave}
                    />}
                </Box>
            </Box>
        </ThemeProvider>
    );
};